<template>
  <ControlWrapper v-bind="controlWrapper" :styles="styles" :is-focused="isFocused" :applied-options="appliedOptions">
    <SectionWrapper
      id="license-plate-confirm"
      :title="computedLabel"
      :title-class="styles.control.label"
      class="flex flex-col"
    >
      <div class="flex w-full flex-col">
        <WInput
          v-model="newStringInput"
          type="text"
          name="stringInput"
          :error="stringInputError || control.errors?.replace('is a required property', 'This field is required') || ''"
          :label="control.schema.description"
          @update:model-value="submitStringInput"
        />
      </div>
    </SectionWrapper>
  </ControlWrapper>
</template>

<script lang="ts" setup>
  import { ControlElement } from '@jsonforms/core';
  import { ref } from 'vue';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue';
  import { useWidgetControl } from '../util';
  import SectionWrapper from 'components/claims-widget/components/SectionWrapper.vue';
  import ControlWrapper from './ControlWrapper.vue';
  import WInput from '../../base/Input.vue';
  import { useDebounceFn } from '@vueuse/core';

  const props = defineProps({
    ...rendererProps<ControlElement>(),
  });
  const { control, controlWrapper, styles, isFocused, appliedOptions, onChange, computedLabel } = useWidgetControl(
    useJsonFormsControl(props)
  );

  const stringInputError = ref('');
  const newStringInput = ref(control.value.data || '');

  const submitStringInput = useDebounceFn(() => {
    onChange(newStringInput.value);
  }, 500);
</script>
